import { CaseStatus } from "../../../api/types/case";

export { statusColor } from "../../../components/case/caseStatusColors";

export type CasesFilter = "all" | "in_progress" | "pending" | "completed";

export const CASES_FILTER_LABEL: Record<CasesFilter, string> = {
  all: "All Cases",
  in_progress: "In Progress",
  pending: "Pending",
  completed: "Completed"
};

export const isCaseStatus = (value: unknown): value is CaseStatus =>
  typeof value === "string" &&
  (Object.values(CaseStatus) as string[]).includes(value);

/**
 * Coarse bucket used by the cases filter: In Progress on its own, terminal
 * statuses as completed, everything else (incl. unknown) pending.
 */
export const getCaseFilterBucket = (
  status?: string | null
): Exclude<CasesFilter, "all"> => {
  const label = (status ?? "").toString().trim();
  if (!label) return "pending";
  if (label === CaseStatus.IN_PROGRESS) return "in_progress";
  if (
    (
      [CaseStatus.APPROVED, CaseStatus.DENIED, CaseStatus.CLOSED] as string[]
    ).includes(label)
  ) {
    return "completed";
  }
  return "pending";
};
